module.exports = __webpack_public_path__ + "fonts/d63b02a0a9f9f57e457330a5bdde7b5c.svg";